/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface PaiementSearch
 */
export interface PaiementSearch {
    /**
     * 
     * @type {number}
     * @memberof PaiementSearch
     */
    idapprenant?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof PaiementSearch
     */
    anneeScolaire?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof PaiementSearch
     */
    datePaiement?: DateSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof PaiementSearch
     */
    idmode?: Int32ListSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof PaiementSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof PaiementSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof PaiementSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaiementSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof PaiementSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PaiementSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the PaiementSearch interface.
 */
export function instanceOfPaiementSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaiementSearchFromJSON(json: any): PaiementSearch {
    return PaiementSearchFromJSONTyped(json, false);
}

export function PaiementSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaiementSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : TextSearchFromJSON(json['anneeScolaire']),
        'datePaiement': !exists(json, 'datePaiement') ? undefined : DateSearchFromJSON(json['datePaiement']),
        'idmode': !exists(json, 'idmode') ? undefined : Int32ListSearchFromJSON(json['idmode']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function PaiementSearchToJSON(value?: PaiementSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'anneeScolaire': TextSearchToJSON(value.anneeScolaire),
        'datePaiement': DateSearchToJSON(value.datePaiement),
        'idmode': Int32ListSearchToJSON(value.idmode),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

